import React, { useEffect, useRef, useState } from 'react'
import DriverCard from '@/components/drivercard'
import './index.scss'
import jp from '@/assets/images/jp.png'
import yp from '@/assets/images/yp.png'
import tp from '@/assets/images/tp.png'
import Bs from '@better-scroll/core'

// import { fleetinfoAction } from '@/store/actions/fleetinfoAction'
// 成员信息action
import { fleetdriverinfoAction } from '@/store/actions/fleetdriverinfoAction'
// 榜单分页
import { rewardamountAction } from '@/store/actions/rewardamountAction'
import { connect } from 'react-redux'
import PullUp from '@better-scroll/pull-up';
import useDeepCompareEffect from 'use-deep-compare-effect'
import fleetBg from '@/assets/images/fleetbg.png'

const fleetBgStyle = {
    backgroundImage :`url(${fleetBg})`,
    backgroundRepeat : 'no-repeat',
    backgroundSize : '100% 50%',
    backgroundAttachment:'fixed'
}
const mapStateToProps = (state) => ({
    //接单
    driverAcceptOrder: state.getIn(['fleetdriverinfoReducer', 'driverAcceptOrder']),
    //取消单子
    driverCancelOrder: state.getIn(['fleetdriverinfoReducer', 'driverCancelOrder']),
    //司机名字
    driverName: state.getIn(['fleetdriverinfoReducer', 'driverName']),
    //在线时长
    onlineTime: state.getIn(['fleetdriverinfoReducer', 'onlineTime']),
    //四否为队长
    isCaptain: state.getIn(['fleetdriverinfoReducer', 'isCaptain']),
    //流水
    payableAmount: state.getIn(['fleetdriverinfoReducer', 'payableAmount']),
    // 奖励金额
    rewardAmount: state.getIn(['fleetdriverinfoReducer', 'rewardAmount']),
    // 是否在线
    status: state.getIn(['fleetdriverinfoReducer', 'status']),
    //车队长名称
    captainName: state.getIn(['fleetdriverinfoReducer', 'captainName']),
    //车队长电话
    captainPhone: state.getIn(['fleetdriverinfoReducer', 'captainPhone']),
    // 榜单分页页数
    pageNum: state.getIn(['rewardamountReducer', 'pageNum']),
    // 分页数据
    fleetList: state.getIn(['rewardamountReducer', 'fleetList']),
    // 分页总数
    total: state.getIn(['rewardamountReducer', 'total']),

})
const mapDispatchToProps = (dispatch) => ({
    // 司机信息
    handleGetDriveInfo() {
        return dispatch(fleetdriverinfoAction());
    },
    // 分页
    handleGetRewardAmount(params) {
        return dispatch(rewardamountAction(params));
    }

})
Bs.use(PullUp)
const MyFleet = (props) => {
    let { rewardAmount, captainName, captainPhone, total, handleGetDriveInfo, driverAcceptOrder, driverCancelOrder, driverName, onlineTime, isCaptain, payableAmount, status, fleetList, handleGetRewardAmount } = props
    // more text
    // let [moretext, setMoretext] = useState('查看更多...')
    // let [pageCount,setPageCount] = useState(1);
    // 分页数组
    let [mypageArr, setMypageArr] = useState([]);
    // 总数
    // let [stateTotal, setStateTotal] = useState(0)
    // better-scroll
    let [BScroll, setBScroll] = useState();
    let wrapper = useRef()
    /**
     * // 司机信息
        handleGetDriveInfo();
        // 分页
         await handleGetRewardAmount({
                pageNo: pageCount,
                pageSize: 8
            })
    */
    // useEffect(() => {
        // 司机信息
        // handleGetDriveInfo();

        // // better-scroll
        // const bscroll = new Bs(wrapper.current, {
        //     scrollY: true,
        //     scrollX: false,
        //     click: true,
        //     probeType: 3,
        //     bounce: {
        //         top: false,
        //     },
        //     deceleration: 0.001,
        //     pullUpLoad: {
        //         threshold: -150 // 当上拉距离超过50px时触发 pullingUp 事件
        //     }

        // })
        // async function handlepullingUp(){
        //     await setPageCount((precountpage) => precountpage + 1);
        //     // 上啦加载
        //     await handleGetRewardAmount({
        //         pageNo: pageCount,
        //         pageSize: 8
        //     })
        //     await bscroll.finishPullUp()
        //     await bscroll.refresh();
        // }
        // bscroll.on('pullingUp', handlepullingUp)
        // if (pageCount * 6 >= total ) {
        //     setMoretext('没有更多数据')
        //     // bscroll.off('pullingUp', handlepullingUp)
        // }
        // // 分页
        // handleGetRewardAmount({
        //     pageNo: 1,
        //     pageSize: 8
        // }).then( () => {
        //     bscroll.refresh();
        // } )
    // }, [])

    // 获取队长数据\分页数据
    useEffect(() => {
        handleGetDriveInfo();
        handleGetRewardAmount({
            pageNo: 1,
            pageSize: 10
        })
    }, [handleGetDriveInfo,handleGetRewardAmount])

    useDeepCompareEffect(() => {
        // 分页赋值
        setMypageArr(() => {
            let newArr = [...mypageArr, ...fleetList]
            return newArr
        });
        // 总数
        // setStateTotal(total)
    }, [fleetList, total])

    useEffect(() => {
        // better-scroll
        const bscroll = new Bs(wrapper.current, {
            scrollY: true,
            scrollX: false,
            click: true,
            probeType: 3,
            bounce: {
                top: false,
            },
            deceleration: 0.001,
            pullUpLoad: {
                threshold: -150 // 当上拉距离超过50px时触发 pullingUp 事件
            }
        })
        setBScroll(bscroll)
        return () => {
            setBScroll(null);
        }
    }, [])

    // better-scroll重新计算
    useEffect(() => {
        if (!BScroll) return
        BScroll.refresh();
    }, [mypageArr])
    // // 分页

    // useEffect(() => {
    //     if (!BScroll) return
    //     function handlepullingUp() {
    //         setPageCount( pageCount += 1 );
    //         // 上啦加载
    //         handleGetRewardAmount({
    //             pageNo: pageCount,
    //             pageSize: 15
    //         }).then( () => {
    //             BScroll.finishPullUp()
    //         } ) 
    //         BScroll.refresh();
    //     }
    //     BScroll.on('pullingUp', handlepullingUp)

    // }, [BScroll])
    // useEffect( () => {
    //     if(!BScroll) return
    //     if( mypageArr.length >= stateTotal && stateTotal > 0 ){
    //         setMoretext('数据加载完毕')
    //     }
    // } ,[mypageArr])

    return (
        <div className="my-fleet_box" style={fleetBgStyle}>
            <header>
                <span><em>{captainName}</em>（车队长）</span>
                <a href={'tel:' + captainPhone}><i className="iconfont icon-dianhua01"></i></a>
            </header>
            <div className="my-fleet-show" ref={wrapper}>
                <div className='my-fleet-scroll'>
                    {/* 当前司机状态 */}
                    <DriverCard
                        driverAcceptOrder={driverAcceptOrder}
                        driverCancelOrder={driverCancelOrder}
                        driverName={driverName}
                        onlineTime={onlineTime}
                        payableAmount={payableAmount}
                        rewardAmount={rewardAmount}
                        status={status}
                        isLeader={isCaptain} />
                    {/* 榜单 */}
                    <div className="fleet-award-info__box">
                        <h2 className="fleet-info-tit__box">-- 车队流水榜单 --</h2>
                        {/* 榜单信息 */}
                        {
                            mypageArr.map((item, index) => (
                                <div className="fleet-info-list" key={index}>
                                    <h5>{item.driverName}</h5>
                                    <span>今日流水：<em>{item.payableAmount}</em>元</span>
                                    {
                                        index === 0 ? <i><img src={jp} alt="" /></i> :
                                            (index === 1 ? <i><img src={yp} alt="" /></i> :
                                                (index === 2 ? <i><img src={tp} alt="" /></i> :
                                                    <i>第{index + 1}名</i>))
                                    }
                                </div>
                            ))
                        }
                        {/* {
                        mypageArr.length >= 15 ? <p className="more">{moretext}</p> : ''
                    } */}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default connect(mapStateToProps, mapDispatchToProps)(MyFleet)
